// compare this query to other ones - you will notice it does not extract any hits
// at all. Why? As we don't know any search criteria, ES would return 'top' documents
// at random order - with score 1.0. These matches are useless, we are much better
// to trust aggregations - where term popularity will be determined by number of matching documents.
export const mostPopularQuery =
  `{
   "query": {
    "match_all": {}
  },
  "aggs": {
    "top_values": {
      "terms": {
         "field": "value.precise",
        "size": "<%=maxCount%>"
      },
      "aggs": {
        "known_categories": {
          "terms": {
             "field": "category",
              "size": "<%=maxCount%>"
          }
        }
      }
    }
  },
  "size": 0
}`;
